import { render, staticRenderFns } from "./PersonProfileAssociatedRecordDetails.vue?vue&type=template&id=cabff7ba&scoped=true&"
import script from "./PersonProfileAssociatedRecordDetails.vue?vue&type=script&lang=js&"
export * from "./PersonProfileAssociatedRecordDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabff7ba",
  null
  
)

export default component.exports